export const selects = {
  selects: {
    dateSelect: {
      last30min: "Last 30 Min.",
      last1hour: "Last 1 Hour",
      last3hours: "Last 3 Hour",
      last1day: "Last 1 Day",
      last3days: "Last 3 Days",
      last7days: "Last 7 Days",
      custom: "Custom",
    },
  },
};
